import { Box, Button, CircularProgress } from '@material-ui/core';

type FormSubmitButtonsProps = {
  onCancel?: () => void;
  onSubmit?: () => void;
  loading?: boolean;
  disabled?: boolean;
  cancelLabel?: string;
  label?: string;
};

export function FormSubmitButtons({
  onCancel,
  onSubmit,
  disabled = false,
  loading = false,
  cancelLabel = 'Cancel',
  label = 'Save',
}: FormSubmitButtonsProps) {
  return (
    <Box display="inline-flex" gridGap={8}>
      <Button
        onClick={onCancel}
        variant="outlined"
        color="default"
        disabled={loading}
        data-track-id="button.cancel"
        data-track-action="dismiss"
      >
        {cancelLabel}
      </Button>
      <Button
        type="submit"
        color="primary"
        variant="contained"
        data-testid="submit-button"
        disabled={loading || disabled}
        onClick={onSubmit}
        data-track-id="button.submit"
        data-track-action="update"
        {...(loading && {
          endIcon: (
            <CircularProgress
              data-testid="progress"
              size="1em"
              color="inherit"
            />
          ),
        })}
      >
        {label}
      </Button>
    </Box>
  );
}
